import type { RfaAddress } from '@innogy/feh/rfa';
import { createAction, props } from '@ngrx/store';

const PREFIX = '[Heatpumps Wizard]';

export const heatpumpsWizardFormSubmitAction = createAction(
  `${PREFIX} Submit form`,
  props<RfaAddress>()
);
